import DOMPurify from "dompurify";

// Sanitise staff-authored rich-text (report/note templates) before rendering as HTML,
// to close off any stored-XSS via dangerouslySetInnerHTML.
export const cleanHtml = (html) => DOMPurify.sanitize(html || "", { USE_PROFILES: { html: true } });

// Manual page-break marker inserted by the rich-text editor. In the exported PDF it forces a
// page break; on screen it is invisible (height:0). Users insert it as a fail-safe.
export const PAGE_BREAK_TOKEN = "\u27E8PAGE BREAK\u27E9"; // ⟨PAGE BREAK⟩
const PB_RE = /<p[^>]*>\s*(?:\u27E8PAGE BREAK\u27E9|\[\[PAGEBREAK\]\])\s*<\/p>/gi;

// Same as cleanHtml but also turns the page-break marker into a real break element and strips
// empty paragraphs that create large vertical gaps in the rendered/printed output.
const EMPTY_P_RE = /<p[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi;
export const cleanReportHtml = (html) =>
    cleanHtml((html || "")
        .replace(PB_RE, '<div class="manual-break" aria-hidden="true"></div>')
        .replace(EMPTY_P_RE, ""));
